import { render, staticRenderFns } from "./OurLeadership.vue?vue&type=template&id=396dce3b&scoped=true&"
import script from "./OurLeadership.vue?vue&type=script&lang=js&"
export * from "./OurLeadership.vue?vue&type=script&lang=js&"
import style0 from "./OurLeadership.vue?vue&type=style&index=0&id=396dce3b&scoped=true&lang=css&"
import style1 from "./OurLeadership.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396dce3b",
  null
  
)

export default component.exports